import styled from 'styled-components'

export const RightTopLeftCard = styled.div<{ windowWidth: number }>`
  background: #fff;
  width: ${({ windowWidth }) =>
    windowWidth < 1340 ? '98%' : windowWidth < 500 ? '95%' : '100%'};
  min-height: 284px;
  border-radius: 20px;
  padding: 24px;
  text-align: center;
  margin: 10px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
`

export const ProductImage = styled.img`
  max-height: 120px;
`

export const ProductWrapper = styled.div`
  display: block;
`

export const SalesText = styled.p`
  font-family: Myraid Pro, sans-serif;
  font-weight: bold;
  font-size: 1em;
  margin: 0;
`

export const ProductBrand = styled.p`
  font-family: Myraid Pro, sans-serif;
  font-weight: 700;
  font-size: 0.7em;
  margin: 0;
`
export const ProductName = styled.p`
  font-family: Myraid Pro, sans-serif;
  font-weight: 100;
  font-size: 0.7em;
  margin: 0;
`

export const CategoryName = styled.p`
  font-family: Myraid Pro, sans-serif;
  font-weight: 100;
  font-size: 0.7em;
  font-style: italic;
  margin: 0;
`
